module.exports = __webpack_public_path__ + "img/fitness-ueberraschung@2x.134ed6c5.png";